import SidebarFilters from './sidebar-filters'

class SidebarFiltersDesktop extends SidebarFilters {
  handleSectionLoad = (): void => {}

  change(): void {
    if (this.shop) {
      this.createFilterQuery()

      this.shop.updateBySearchParams(this.searchParams)
    }
  }
}

export default SidebarFiltersDesktop
